import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { save, load } from 'redux-localstorage-simple'
import { useDispatch } from 'react-redux'
import farmsReducer from './farms'
import poolsReducer from './pools'
import clPoolReducer from './clpools'
import boostersReducer from './boosters'
import blockReducer from './block'
import infoReducer from './info'
import statsReducer from './stats'
import { updateVersion } from './global/actions'
import user from './user/reducer'
import transactions from './transactions/reducer'
import swap from './swap/reducer'
import zap from './zap/reducer'
import mint from './mint/reducer'
import lists from './lists/reducer'
import burn from './burn/reducer'
import multicall from './multicall/reducer'

import network from './network'
import appSlice from "~/state/app/appModeSlice";

const PERSISTED_KEYS: string[] = ['user', 'transactions', 'lists']

const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    appMode: appSlice,
    block: blockReducer,
    farms: farmsReducer,
    pools: poolsReducer,
    clPools: clPoolReducer,
    info: infoReducer,
    boosters: boostersReducer,
    stats: statsReducer,
    // Exchange
    user,
    transactions,
    swap,
    zap,
    mint,
    burn,
    multicall,
    lists,
    network
  },
  middleware: [...getDefaultMiddleware({ thunk: true }), save({ states: PERSISTED_KEYS })],
  preloadedState: load({ states: PERSISTED_KEYS }),
})

store.dispatch(updateVersion())

/**
 * @see https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-dispatch-type
 */
export type AppDispatch = typeof store.dispatch
export type AppState = ReturnType<typeof store.getState>
export const useAppDispatch = () => useDispatch()

export default store
